<template lang="jade">
  form.Form(":skin"="skins.form"
            ":id"="id"
            class="Form--standard animated fadeIn")
    div.Form__body
      partial(name="rawhtml")
</template>

<script>
    import forms from './_shared/traits'
    import nav from '../nav/index'
    import datagrid from 'src/components/tables/datagrid'
    import dataList from 'src/components/tables/dataList'

    export default {
      mixins: [forms],

      components: {
        navigation: nav.tiled,
        profile: require('../nav/profile'),
        type_fieldset: require('./_sub/fieldsets/standard'),
        type_title: require('./_sub/title'),
        type_dataTable: datagrid,
        type_htmlTable: dataList
      },

      partials: {
        rawhtml: ''
      },

      props: {
        uid: {
          type: String
        }
      },

      data: () => ({}),

      beforeCompile () {
        let {fields} = this.form
        let rawHTML = fields.reduce((str, n, idx) => {
          if (n.type === 'type_rawHtml') return str + n.value
          return str + `<component :is="form.fields[${idx}].type" :fdata="form.fields[${idx}]"> </component>`
        }, '')
        this.$options.partials = {
          rawhtml: rawHTML
        }
      }
    }
</script>



// WEBPACK FOOTER //
// standard.vue?66069596